import {Badge} from '@orbit-ui/components/badge';
import {TableRow, TableCell} from '@orbit-ui/components/table';
import {TimeAgo} from '@orbit-ui/components/time-ago';
import {WorkOSEvent} from '../types/events';

type EventItemProps = {
  event: WorkOSEvent;
};

/**
 * Component to display a single event in the events table
 */
export function EventItem({event}: EventItemProps) {
  // Format event type for display
  const formatEventType = (type: string): string =>
    type.replace('authentication.', '').replaceAll('_', ' ');

  // Get badge variant based on event type
  const getBadgeVariant = (type: string): 'default' | 'destructive' | 'secondary' => {
    if (type.includes('succeeded')) return 'default'; // green
    if (type.includes('failed')) return 'destructive'; // red
    return 'secondary'; // neutral
  };

  // Get user email or ID from event data
  const getUserInfo = (): string => {
    if (event.data.user?.email) return event.data.user.email;
    if (event.data.user?.id) return event.data.user.id;
    return 'Unknown user';
  };

  // Get connection type from event data
  const getConnectionType = (): string => {
    if (event.data.connection?.type) return event.data.connection.type;
    return 'Unknown';
  };

  return (
    <TableRow>
      <TableCell>
        <Badge variant={getBadgeVariant(event.event_type)}>
          {formatEventType(event.event_type)}
        </Badge>
      </TableCell>
      <TableCell>{getUserInfo()}</TableCell>
      <TableCell>{getConnectionType()}</TableCell>
      <TableCell>
        <TimeAgo date={event.occurred_at} />
      </TableCell>
    </TableRow>
  );
}
